import React, { useState } from 'react';
import { useStyles } from './styles';
import { Box, Button, Typography, TextareaAutosize, CircularProgress, Grid } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DeleteIcon from '@material-ui/icons/Delete';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { uploadSupportDocuments, downloadSupportDocument, submitReopenSupportTicket, deleteSupportDocuments } from '../../../actions';
import { getAppSource, getUserType, renderDefaultMsg } from '../../../helpers';
import { FILE_LENGTH_LIMIT } from '../../../helpers/constants';
import { FileSizeAlert } from '../../PayoffRequest/FileSizeAlert';
import { FileExtensionAlert } from '../../IdentityThefts/FileExtensionAlert';
import { styled } from '@material-ui/core/styles';
import pdfIcon from '../../../assets/SupportTicket/pdfIcon.svg';
import imageIcon from '../../../assets/image.png';
import Cookies from 'js-cookie';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export const TicketReopenPopup = (props) => {

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const accounts = useSelector(state => state.accounts);
  
  const [documentDesc, setDocumentDesc] = useState("");
  const [loader, setLoader] = useState(false);
  const [file, setFilesName] = useState('');
  const [fileLengthStatus, setFileLengthStatus] = useState(false);
  const [errMessage, setErrorMessage] = useState('');
  const [commentDocs, setCommentDocs] = useState([]);
  const [counter, setCounter] = useState(1);
  const [alertStatus, setAlertStatus] = useState(false);
  const [fileUploadLoader, setFileUploadLoader] = useState(false);
  const [allowedExtensionsStatus, setAllowedExtensionsStatus] = useState(false);
     
  const handleExtensionAlertClose = () => setAllowedExtensionsStatus(false)
  const handleAlertClose = () => {
    setAlertStatus(false)
  }

  const handleRequestDescChange = (event) => {
    setDocumentDesc(event.target.value.replace(/^\s+/, ''))
  }

  const handleInputFile = (e) => {
    e.target.value = null;
  }

  const handleFile = (event, replace) => {
      var allowedExtensions = /(\.png|\.jpg|\.pdf|\.jpeg)$/i;
      var specialCharacters =  /[\/:*?“<>|]/;
      var fileSize =  event.target.files[0].size / 1024 / 1024
      if (fileSize > 5) {
        setFilesName(event.target.files[0].name)
        setAlertStatus(true)
      } else if (!allowedExtensions.exec(event.target.value)) { 
        setFilesName(event.target.files[0].name)
        setAllowedExtensionsStatus(true)
      } else if (event.target.files[0].name.length > FILE_LENGTH_LIMIT) {
        setFilesName(event.target.files[0].name)
        setFileLengthStatus(true)
      }  else if (specialCharacters.test(event.target.files[0].name)) {
        setFilesName(event.target.files[0].name)
        setFileContainSpecialChar(true) 
      } else {
        onFileUpload(event.target.files[0], replace)
      }
    };
    
    const onFileUpload = async (file, replace) => {
      setFileUploadLoader(true)
      setErrorMessage('');
      const res = await uploadSupportDocuments(props.accountNumber, file, commentDocs.length, replace, counter);
      if (res && res?.responseData?.lstResponseStatus && (res?.responseData.lstResponseStatus[0]?.statusCode == 0)) { 
        setFileUploadLoader(false)
        let newObj = [...commentDocs]
        newObj.push({documentName: file.name, documentId: res.responseData.responseData})
        setCommentDocs(newObj)
      } else if (res && res?.responseData?.lstResponseStatus && (res?.responseData.lstResponseStatus[0]?.statusCode !== 0)) {
        setFileUploadLoader(false)
        setErrorMessage(res.lstResponseStatus[0].statusDesc)
      } else {
        setFileUploadLoader(false)
        setErrorMessage(renderDefaultMsg('400'));
      };
    }  

  const downloadDocuments = async (docName, documentId) => {
      const response = await downloadSupportDocument(props.accountNumber, documentId)
      if (response) {
        const url = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', docName);
        document.body.appendChild(link);
        link.click();
        if (docName.includes('pdf')) {
          var a = document.createElement('a');
          a.target="_blank";
          a.href = url;
          a.click();
        }
      }
  }

  const handleReopenTicket = async () => {
    setErrorMessage('');
    setLoader(true)
    const data = {
      "supportRequestId": props.supportTicketId,
      "isReopen": true,
      "comment": documentDesc,
      "documentId":  commentDocs.map((key) => key.documentId),
      "accountNumber": accounts.length == 1 ? props?.accountNumber : props.selectedLoan.accountNumber,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };

    const res = await submitReopenSupportTicket(data);
    if (res?.responseData?.lstResponseStatus[0]?.statusCode == 0) {
      setLoader(false)
      setErrorMessage("");
      setDocumentDesc("");
      setCommentDocs([]);
      props.submitReopenTicket()
    } else {
      setLoader(false)
      setErrorMessage(renderDefaultMsg('400'))
    }
  }

  const deleteDocuments = async (id) => {
    setErrorMessage('');
    const response = await deleteSupportDocuments(props.accountNumber, id)
    if (response && response?.responseData?.lstResponseStatus && (response?.responseData.lstResponseStatus[0]?.statusCode == 0)) {  
      let newObj = [...commentDocs]  
      newObj.splice(0, 1)
      setCommentDocs(newObj)
    }  else if (response && response?.responseData?.lstResponseStatus && (response?.responseData.lstResponseStatus[0]?.statusCode !== 0)) {
      setErrorMsg(response.lstResponseStatus[0].statusDesc)
    } else {
      setErrorMessage(renderDefaultMsg('400'));
    }
  }

  const shortText = (text) => {
    if (text !== '') {
      return text.length < 25 ? text : text.substr(0, 25) + '...'
    } else {
      return text
    }
  }

  const closeReasonForReopenPopup = () => {
    setErrorMessage("")
    setDocumentDesc("");
    setCommentDocs([]);
    props.closeReopenPopup();
  }
 
  return (
    <>
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle }}} onClose={props.handleCancelIcon} open={props.open} className={classes.dialogClass}>
      <Box className={classes.root}>
        
        <Box className={classes.cardBody}>
          <Typography className={classes.statusTitle}>Reopen Ticket</Typography>
        </Box>
        
        <Box className={classes.cardBodyContainer}>
          <Typography className={classes.errorMsg} dangerouslySetInnerHTML={{ __html: errMessage !== '' ? errMessage : '' }} />
          <Box className={classes.statusContainer}>
                 <Box className={classes.textareaSection}>
                    <label style={{ fontWeight: 'bold', fontSize: '12px' }}>
                        Reason for Reopen <span style={{ color: 'red' }}>*</span>
                    </label>
                    <TextareaAutosize
                      style={{ height: '102px' }}
                      color="primary"
                      variant="outlined"
                      type="text"
                      name="comments"
                      maxLength="500"
                      onChange={(event) => handleRequestDescChange(event)}
                      value={documentDesc}
                      InputLabelProps={{
                        FormLabelClasses: {
                          asterisk: classes.labelAsterisk
                        }
                      }}
                      className={classes.textArea}

                    >
                    </TextareaAutosize>
                    {/* <Typography className={classes.textAreaValidation}>{calculateCommentLenth()}/5000</Typography> */}
                    <Box className={classes.fileUpload}>
                        <Box className={classes.chooseFile}>
                          Attach a file (Optional):
                        </Box>
                        <Box>
                        <input
                            accept=".pdf, .png, .jpg, .jpeg"
                            type="file"
                            name='selectedFile'
                            style={{display: 'none'}}
                            id="upload-button"
                            onClick={(e) => handleInputFile(e)}
                            onChange={(e) => handleFile(e, true)}
                            
                          />
                          {/* <Button component="label" variant="contained" className={classes.fileButton} disabled={(commentDocs.length == 1)}>
                            CHOOSE FILE
                            <VisuallyHiddenInput type="file"  accept=".pdf, .png, .jpg, .jpeg" onClick={(e) => handleInputFile(e)}
                            onChange={(e) => handleFile(e, false)} />
                          </Button> */}
                          {fileUploadLoader ? 
                            <Button component="label" type='submit' className={classes.fileButton} variant="contained" color='primary'>
                              <CircularProgress color='primary' />
                            </Button>
                          :
                          <Button component="label" variant="contained" className={(commentDocs.length == 1) ? classes.disableFileBtn : classes.fileButton} disabled={(commentDocs.length == 1)}>
                            <Box className={(commentDocs.length == 1) ? classes.disableChooseBtn : classes.chooseFile}>CHOOSE FILE</Box>
                            <VisuallyHiddenInput type="file"  accept=".pdf, .png, .jpg, .jpeg" onClick={(e) => handleInputFile(e)}
                            onChange={(e) => handleFile(e, false)} />
                          </Button> }
                          
                        </Box>
                        <Box className={`${classes.chooseFile} info`} >
                          Only 1 file(PDF, JPG, PNG, JPEG) allowed of 5 MB 
                        </Box>
                    </Box>

                     <Grid container >
                      { (commentDocs.length > 0) && commentDocs.map((key) => {  
                        return (
                          <Grid item xs={12} sm={12} md={6}>
                            <Box className={classes.uploadedImageContainer}>
                              <Box className={classes.uploadedImage}>
                                  {key.documentName.includes('.pdf') ? <img className={classes.checkImg} src={pdfIcon} alt='image' /> :
                                   <img className={classes.checkImg} src={imageIcon} alt='image' /> }
                                   <Typography className={classes.imageText} onClick={() => downloadDocuments(key.documentName, key?.documentId)}>{shortText(key.documentName)} </Typography>
                                  
                                    <DeleteIcon color="action" onClick={() => deleteDocuments(key?.documentId)} style={{cursor: 'pointer', color: '#4D4D4D', marginRight: 10}}></DeleteIcon>                                
                              </Box>
                            </Box>
                        </Grid>
                        )})}
                   </Grid> 

                </Box>              
          </Box>
        </Box>

        
        <Grid container className={classes.footerSection}>
            <Grid item xs={5} md={6} className={classes.pr35}>
              <Box className={classes.cancelBtnBox}>
                <Button
                  className={classes.cancelBtn}
                  variant="outlined"
                  onClick={() => closeReasonForReopenPopup()}
                >CANCEL</Button>
              </Box>
            </Grid>
            <Grid item xs={7} md={6} className={classes.pl35}>
              <Box className={classes.saveBtnBox}>
                {loader ?
                  <Button disabled={true} type='submit' className={classes.saveBtn} variant="contained" color='primary'>
                    <CircularProgress color='primary' />
                  </Button>
                  :
                  <Button
                    className={classes.saveBtn}
                    variant="contained"
                    onClick={() => handleReopenTicket()}
                    disabled={documentDesc.trim().length == 0}
                    color="primary">
                    SUBMIT</Button>}
              </Box>
            </Grid>
        </Grid>

      </Box> 
    </Dialog>
     <FileSizeAlert
        open={alertStatus}
        handleAlertClose={handleAlertClose}
        file={file}
      />
       <FileExtensionAlert
          open={allowedExtensionsStatus}
          handleExtensionAlertClose={handleExtensionAlertClose}
          file={file}
        />
    </>  
  )
}
